import {
  Building2Icon,
  CalendarRangeIcon,
  InboxIcon,
  LayoutDashboardIcon,
  UserRoundIcon,
} from 'lucide-react-native';
import type { LucideIcon } from 'lucide-react-native';

export type BusinessTabRouteName = 'home' | 'events' | 'inbox' | 'organization' | 'you';

export type BusinessNavItem = {
  icon: LucideIcon;
  label: string;
};

export const BUSINESS_TAB_CONFIG: Record<BusinessTabRouteName, BusinessNavItem> = {
  home: { icon: LayoutDashboardIcon, label: 'Home' },
  events: { icon: CalendarRangeIcon, label: 'Events' },
  organization: { icon: Building2Icon, label: 'Venue' },
  inbox: { icon: InboxIcon, label: 'Inbox' },
  you: { icon: UserRoundIcon, label: 'Profile' },
};
